<template>
    <div class="carousel-wrapper">
        <div class="bs-container">
            <div class="bs-row justify-content-center">
                <div class="c c-lg-12 carousel-title">
                    <div class="carousel-title__name">
                        <h3>
                            {{ title }}
                        </h3>
                    </div>
                    <div class="carousel-title__link">
                        <a href="trziste-sazenek" class="btn btn-link ico-a-arrow-right">všechny</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="carousel-container">
            <div class="carousel-blur left">
                <DsButton
                    :class="{ 'carousel-button--disabled': current === 0 }"
                    class="carousel-button carousel-button--prev"
                    @click="carousel.prev()"
                    icon-left="arrow-left"
                    aria-label="Předešlý slide"
                ></DsButton>
            </div>
            <div class="bs-container">
                <div class="bs-row justify-content-center">
                    <div class="c c-lg-12">
                        <div class="bs-row keen-slider" ref="carouselRef">
                            <SyndicateCard v-for="(bet, i) in data" :data="bet" :key="i" :carouselCard="true" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="carousel-blur right">
                <DsButton
                    v-if="carousel"
                    class="carousel-button carousel-button--next"
                    :class="{
                        'carousel-button--disabled': current >= carousel?.track.details?.maxIdx,
                    }"
                    @click="carousel.next()"
                    icon-right="arrow-right"
                    aria-label="Následujicí slide"
                ></DsButton>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref } from "vue";
import SyndicateCard from "./syndicate-card.vue";
import { KeenSliderInstance } from "keen-slider";
import { useKeenSlider } from "keen-slider/vue.es";
import { SyndicatePreview } from "@/lotteries/model/syndicates/syndicate-preview";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";

defineProps<{
    title: string;
    data: SyndicatePreview[];
}>();

const current = ref(0);

const [carouselRef, carousel] = useKeenSlider<HTMLDivElement>({
    slides: {
        perView: 1.2,
    },
    breakpoints: {
        /* eslint-disable */
        "(min-width: 366px)": {
            slides: {
                perView: 1.5,
            },
        },
        "(min-width: 541px)": {
            slides: {
                perView: 2,
            },
        },
        "(min-width: 1221px)": {
            slides: {
                perView: 3,
            },
        },
    },
    slideChanged: (s: KeenSliderInstance) => {
        current.value = s.track.details.abs;
    },
});
</script>
